import api from './api';

export default async function downloadImage(id: string) {

  try {  
    const response = await api.get(`/image-generation/v1/images/${id}?mode=original`);
    const link = document.createElement('a');
    link.href = response.data.url;
    link.download = id;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.log(error, 'error is geneted will calling the /image-generation/v1/images/${id}?mode=original ');
    throw error;
  }
}